import { Flex } from "@chakra-ui/react";
import OutlineButton from "ui/components/Button/OutlineButton";
import DefaultButton from "ui/components/Button/PrimaryButton";

interface FooterModalFiltrosProps {
  value: number;
  onCancel: () => any;
  onSubmit: () => void;
}

function FooterModalFiltros({
  value,
  onCancel,
  onSubmit,
}: FooterModalFiltrosProps) {
  return (
    <Flex flex={1} justifyContent="end" gap={4}>
      <OutlineButton onClick={onCancel}> Cancelar</OutlineButton>
      <DefaultButton onClick={onSubmit}>
        Filtrar
        {value !== 0 ? `(${value})` : null}
      </DefaultButton>
    </Flex>
  );
}

export default FooterModalFiltros;
